var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000450134 3.84615C-0.000450134 1.72692 1.72647 0 3.84571 0H19.9995C22.1188 0 23.8457 1.72692 23.8457 3.84615V16.1538C23.8457 18.2731 22.1188 20 19.9995 20H3.84571C1.72647 20 -0.000450134 18.2731 -0.000450134 16.1538V3.84615ZM9.99955 17.6923H19.9995C20.8495 17.6923 21.538 17.0038 21.538 16.1538V3.84615C21.538 2.99615 20.8495 2.30769 19.9995 2.30769H9.99955V17.6923ZM2.30724 16.1538C2.30724 17.0038 2.9957 17.6923 3.84571 17.6923H7.69186V2.30769H3.84571C2.9957 2.30769 2.30724 2.99615 2.30724 3.84615V16.1538Z",
    strokeWidth: 0,
    fill: "#38393C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3071 6.53809L14.0962 9.42786C13.7567 9.73343 13.7567 10.2658 14.0962 10.5714L17.3071 13.4612",
    stroke: "#38393C",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLeft);
export default __webpack_public_path__ + "static/media/collapse-left.fdbf36ab7f392c0adb27e341583ab4c8.svg";
export { ForwardRef as ReactComponent };